import {Component, OnDestroy, OnInit} from '@angular/core';
import {StateService} from '@core/services/state.service';
import {UserService} from '@core/services/user.service';
import {User} from '@shared/models/user';
import {TeamService} from '@core/services/team.service';
import {AppTeam} from '@shared/models/team';
import {ClubService} from '@core/services/club.service';
import {SnackbarService} from '@core/services/snackbar.service';
import {Club} from '@shared/models/club';
import {EntityType} from '@lib/models/entity/entity-type';
import {FollowService} from '@core/services/follow/follow.service';

@Component({
  selector: 'app-club-teams',
  templateUrl: './club-teams.component.html',
  styleUrls: ['./club-teams.component.scss']
})
export class ClubTeamsComponent implements OnInit, OnDestroy {
  userSubscription;

  public teamsLoading = true;
  public team: AppTeam;
  public currentUser: User;

  public club: Club;
  public teams: AppTeam[] = [];
  public loading = false;

  constructor( private userService: UserService,
               private teamService: TeamService,
               private clubService: ClubService,
               private followService: FollowService) { }

  public async ngOnInit() {
    this.userService.getCurrentUser().then(cu => this.currentUser = cu);
    this.userSubscription = this.userService.currentUserSubject.subscribe(user => this.currentUser = user);

    this.team = this.teamService.getCurrentTeam();
    this.teamsLoading = true;

    if (this.team.clubid == null) {
      console.error('team.clubid is null');
      this.teamsLoading = false;
      return;
    }

    this.club = await this.clubService.fetchClub(this.team.clubid);

    this.loadTeams();
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  private loadTeams() {
    if (this.team == null || this.team.clubid == null) {
      this.teamsLoading = false;
      return;
    }

    this.clubService.fetchClubTeams(this.team.clubid).then(teams => {
      if (teams) {
        this.teams = teams;
      } else {
        this.teams = [];
      }

      this.teamsLoading = false;
    });
  }

  public async toggleFollow(follow: boolean, id: string) {
    if (this.loading === true) {
      return;
    }

    this.loading = true;
    const name = this.teams.find(value => value.id === id).name;
    await this.followService.toggleFollow(follow, EntityType.Team, name, id);

    // update teams list
    this.userService.getCurrentUser().then(cu => {
      this.currentUser = cu;
      this.loading = false;
    })
  }
}
